import { oc } from '@orpc/contract';
import { createPublishedResultInputSchema, publishedVehicleResultSchema } from '../schemas/vehicles.schemas.js';
export const createPublishedResultContract = oc
    .route({
    method: 'POST',
    path: '/vehicles/{vehicleId}/published-results',
    tags: ['Vehicles'],
    summary: 'Record a published reference figure (WLTP/EPA/GCC) for a vehicle',
    description: 'MANAGER only. Published figures are always shown labelled and never mixed with measured runs.',
})
    .input(createPublishedResultInputSchema)
    .output(publishedVehicleResultSchema);
//# sourceMappingURL=create-published-result.contract.js.map